import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { connect } from "react-redux";
// import Axios from "axios";

import UserBar from "./UserBar/UserBar";
import { useStyles } from "./UserHeader.css";
// import { url } from "../../../../Config/Config";
import UserDrawer from "./UserDrawer/UserDrawer";

class UserHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { open: true };
  }

  handleDrawerOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleDrawerClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { open } = this.state;
    return (
      <div>
        <UserBar
          open={open}
          role={this.props.role}
          handleDrawerOpen={this.handleDrawerOpen}
        />
        <div className={classes.sectionDesktop}>
          <UserDrawer
            open={open}
            role={this.props.role}
            handleDrawerClose={this.handleDrawerClose}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(UserHeader));
